import { Center, Spinner, Text } from '@chakra-ui/react';
import { Navigate } from 'react-router-dom';
import { Trans } from '@lingui/react/macro';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';

// Land on the first panel (Overview) when opening DB Stats with no panel selected.
export function DbStatsIndex() {
  const { data: panels } = trpcAdmin.db.panels.useQuery();

  if (panels === undefined) {
    return (
      <Center h="full" p="8">
        <Spinner color="purple.500" size="lg" />
      </Center>
    );
  }

  const firstPanel = panels[0];
  if (firstPanel === undefined) {
    return (
      <Center h="full" p="8">
        <Text color="fg.muted" fontSize="sm">
          <Trans>No panels available.</Trans>
        </Text>
      </Center>
    );
  }

  return <Navigate to={`/developer-tools/db-stats/${firstPanel.id}`} replace />;
}
